var React = require('react');

function Profile (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M7.99992 1.33334C4.31992 1.33334 1.33325 4.32001 1.33325 8.00001C1.33325 11.68 4.31992 14.6667 7.99992 14.6667C11.6799 14.6667 14.6666 11.68 14.6666 8.00001C14.6666 4.32001 11.6799 1.33334 7.99992 1.33334ZM7.99992 3.33334C9.10659 3.33334 9.99992 4.22668 9.99992 5.33334C9.99992 6.44001 9.10659 7.33334 7.99992 7.33334C6.89325 7.33334 5.99992 6.44001 5.99992 5.33334C5.99992 4.22668 6.89325 3.33334 7.99992 3.33334ZM7.99992 12.8C6.33325 12.8 4.85992 11.9467 3.99992 10.6533C4.01992 9.32668 6.66659 8.60001 7.99992 8.60001C9.32659 8.60001 11.9799 9.32668 11.9999 10.6533C11.1399 11.9467 9.66659 12.8 7.99992 12.8Z"}));
}

Profile.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = Profile;

Profile.default = Profile;
